import { createSlice } from "@reduxjs/toolkit";
import {
  healthcareAuditSteps,
  guardianOrdinanceAuditSteps,
  careDirectiveAuditSteps,
  organDonationAuditSteps,
  custodyOrderAuditSteps,
  uploadedDocumentsAuditsNames,
} from "../../constants/constants";
const initialValues = {
  healthcare: [],
  guardianOrdinance: [],
  custodyOrder: [],
  careDirective: [],
  organDonation: [],
  statusQuoMedia: [],
};
const initialState = {
  updates: initialValues,
};

export const DocumentsSlice = createSlice({
  name: "updates",
  initialState,
  reducers: {
    getUpdatedData: (state, action) => {
      state.updates = initialValues;
      if (
        action.payload.filter((item) =>
          healthcareAuditSteps.includes(item.objectName.toLowerCase())
        )
      ) {
        state.updates = {
          ...state.updates,
          healthcare: action.payload.filter((item) =>
            healthcareAuditSteps.includes(item.objectName.toLowerCase())
          ),
        };
      }
      if (
        action.payload.filter((item) =>
          guardianOrdinanceAuditSteps.includes(item.objectName.toLowerCase())
        )
      ) {
        state.updates = {
          ...state.updates,
          guardianOrdinance: action.payload.filter((item) =>
            guardianOrdinanceAuditSteps.includes(item.objectName.toLowerCase())
          ),
        };
      }
      if (
        action.payload.filter((item) =>
          custodyOrderAuditSteps.includes(item.objectName.toLowerCase())
        )
      ) {
        state.updates = {
          ...state.updates,
          custodyOrder: action.payload.filter((item) =>
            custodyOrderAuditSteps.includes(item.objectName.toLowerCase())
          ),
        };
      }
      if (
        action.payload.filter((item) =>
          careDirectiveAuditSteps.includes(item.objectName.toLowerCase())
        )
      ) {
        state.updates = {
          ...state.updates,
          careDirective: action.payload.filter((item) =>
            careDirectiveAuditSteps.includes(item.objectName.toLowerCase())
          ),
        };
      }
      if (
        action.payload.filter((item) =>
          organDonationAuditSteps.includes(item.objectName.toLowerCase())
        )
      ) {
        state.updates = {
          ...state.updates,
          organDonation: action.payload.filter((item) =>
            organDonationAuditSteps.includes(item.objectName.toLowerCase())
          ),
        };
      }
      if (
        action.payload.filter((item) =>
          uploadedDocumentsAuditsNames.includes(item.objectName.toLowerCase())
        )
      ) {
        state.updates = {
          ...state.updates,
          statusQuoMedia: action.payload.filter((item) =>
            uploadedDocumentsAuditsNames.includes(item.objectName.toLowerCase())
          ),
        };
      }
    },
  },
});

export const { getUpdatedData } = DocumentsSlice.actions;

export default DocumentsSlice.reducer;
